<template>
  <b-container fluid>
    <backlink />
    <h1>Popup</h1>
    <AdminForm
      :config="config"
      :form="form"
      :isBusy="isBusy"
      @submit:create:success="postFile"
      @submit:update:success="postFile"
    ></AdminForm>
  </b-container>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "PopupEdit",
  components: {
    AdminForm,
  },
  data() {
    return {
      config: config,
      form: {},
      isBusy: false,
      initialForm: {},
    };
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            stored_file_id: item.stored_file ? item.stored_file.id : null,
            stored_file: item.stored_file ? item.stored_file.file : null,
          };

          // On sauvegarde les données initiales, donc avant modification dans le form, pour ensuite
          // les utiliser dans la gestion des fichiers joints
          this.initialForm = _.cloneDeep(this.form);
          this.isBusy = false;
        });
    }
  },
  methods: {
    postFile(response) {
      const popup_id = response.data.object.id;

      // Gestion de la photo principale supprimée
      // On compare les données du formulaire avant modification avec mes données modifiées
      // pour identifier les fichiers supprimés
      if (this.initialForm.stored_file && this.initialForm.stored_file_id) {
        // Si le fichiers courant n'est plus dans les fichiers du formulaire, c'est qu'il faut le supprimer
        if (this.form.stored_file != this.initialForm.stored_file) {
          this.$store
            .dispatch("stored_file/deleteItem", this.initialForm.stored_file_id)
            .then((response) => {
              this.$store.dispatch(config.storeNamespace + "/getItem", {
                id: popup_id,
              });
            });
        }
      }

      // Si il ya une photo principale
      if (this.form.stored_file && typeof this.form.stored_file == "object") {
        // Si il ne s'agit pas d'un fichier déjà présent
        let item = {
          popup_id: popup_id,
          type_slug: "popup-picture",
          format: this.form.stored_file.type,
          file: this.form.stored_file,
        };

        this.$store.dispatch("stored_file/addItem", item).then((response) => {
          this.$store
            .dispatch(config.storeNamespace + "/getItem", {
              id: popup_id,
              wait: true,
            })
            .then(() => {
              this.$router.go(0);
            });
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Popup/PopupEdit.vue